<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Sync Student Canteen Fees</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
            <v-col cols="12" sm="2">
            <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
           <v-col cols="12" sm="2" v-if="standard_list!=''">
            <p><v-icon color="error">*</v-icon><b>Standard</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="standard"
              :items="standard_list"
              item-text="standard"
              item-value="id"
              label="Standard"
              outlined
              persistent-hint
              hint="Please Select Standard"
              multiple
            />
          </v-col>
           <v-col cols="12" sm="1" md="1" align="center" class="pt-4 mt-5" v-if="ay">
                <v-btn class="button" @click="syncLearnerCanteenFees()" :loading="loader">Sync</v-btn>
            </v-col>
            </v-row>
       </v-card>

     <!-- <v-card class="box" v-if="query_list.length > 0">
     <v-data-table  :headers="headers" :items="query_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Queries</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
     </v-data-table>
 </v-card> -->
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      ay_list: [],distance_slab_list:[],
      standard_list:[],standard:"",
      ay: "",distance_slab:"",
      headers:[
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      ],
  }),
   methods: {
    async syncLearnerCanteenFees() {
        this.distance_slab_list=[] 
         const data = {
            ay: this.ay,
            standard:this.standard
      };
      this.overlay = true;
      this.loader = true;
      try {
        const res = await axios.post("/Canteen/saveSyncLearnerCanteenFees",data);
        if (res.data.flag == "YES") { 
         this.showSnackbar("green", "Synced Successfully..."); // show snackbar
         this.standard=""
         this.ay=""
        }
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
        this.overlay = false;
        this.loader = false;
      }
    },
    async onLoad() {
      try {
        const res = await axios.post("/Canteen/syncLearnerCanteenFees");
        if (res.data.flag == "YES") {
          this.ay_list = res.data.ay_list;
          this.standard_list = res.data.standard_list;
          this.ay = res.data.cay;
        }
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
        //this.save_loader = false;
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>